"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PagePlace = void 0;
var PagePlace;
(function (PagePlace) {
    PagePlace["sidebar"] = "sidebar";
    PagePlace["main"] = "main";
    PagePlace["footer"] = "footer";
    PagePlace["menu"] = "menu";
    PagePlace["byTheme"] = "byTheme";
})(PagePlace = exports.PagePlace || (exports.PagePlace = {}));
